export default {
  import: {
    classifyName: '供应商分类',
    supplierName: '供应商简称',
    invitationEmail: '邀请邮箱',
    contactPerson: '联系人',
    contactInfo: '联系方式(手机号)',
    registrationType: '注册类型',
    invitationCode: '邀请码',
    status: '状态',
    adddate: '创建日期',
    statusOptions: ['初建', '已邀请', '已注册'],
    classifyNo: '供应商分类',
    sendInvitationTip: '是否发送邀请？',
    sendInvitation: '发送邀请'
  },
  progress: {
    classifyName: '供应商分类',
    supplierShortName: '供应商简称',
    supplierName: '企业全称',
    creditCode: '统一社会信用代码',
    legalRepresentative: '法定代表人',
    legalRepresentativeMobile: '联系方式',
    status: '状态',
    statusOptions: ['注册', '合格', '不合格', '初建', '已邀请'],
    ticket: '营业执照',
    statusInfo: '状态详情',
    showFileWarning: '文件加载失败',
    statusTitle: '状态详情',
    addName: '操作人',
    adddate: '操作时间'
  }
}
